import React from "react";
import "../../../i18n";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UsersManagement = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{t("admin_users.title")}</h4>
              <div className="d-flex flex-column gap-2 mt-4 align-items-start">
                <Link to="/users-management/list" className="btn btn-primary">
                  {t("admin_users.buttons.list")}
                </Link>
                <Link
                  to="/users-management/list?package=premium"
                  className="btn btn-warning"
                  style={{ backgroundColor: "#FF6B57", borderColor: "#FF6B57", color: "#ffffff" }}
                >
                  {t("admin_users.buttons.premium_list")}
                </Link>
                <Link
                  to="/users-management/list?package=standard"
                  className="btn btn-secondary"
                  style={{ backgroundColor: "#F24B8A", borderColor: "#F24B8A", color: "#ffffff" }}
                >
                  {t("admin_users.buttons.standard_list")}
                </Link>
                <Link
                  to="/users-management/active"
                  className="btn btn-outline-primary"
                  style={{ backgroundColor: "#7EC8FF", borderColor: "#7EC8FF", color: "#ffffff" }}
                >
                  {t("admin_users.buttons.active")}
                </Link>
                <Link
                  to="/users-management/create"
                  className="btn btn-success"
                  style={{ backgroundColor: "#D97ADF", borderColor: "#D97ADF", color: "#ffffff" }}
                >
                  {t("admin_users.buttons.create")}
                </Link>
                <Link to="/users-management/edit" className="btn btn-success" style={{ backgroundColor: "#A8E06E", borderColor: "#A8E06E", color: "#ffffff" }}>
                  {t("admin_users.buttons.edit")}
                </Link>
              <Link
                to="/users-management/assign-business"
                className="btn btn-warning"
                style={{ backgroundColor: "#F4B740", borderColor: "#F4B740", color: "#ffffff" }}
              >
                {t("admin_users.buttons.assign_business")}
              </Link>
            </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersManagement;
